import { Button, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";

import AppIcon from "@/common/components/Icons/AppIcon";
import { RepairMaterialDto } from "@/core/api/generated/v1";

import RepairMaterialAutocomplete, {
  RepairMaterialAutocompleteProps,
} from "./RepairMaterialAutocomplete";
import RepairMaterialCreateUpdate, {
  RepairMaterialCreateUpdateProps,
} from "./RepairMaterialCreateUpdate";
import RepairMaterialCreateUpdateModal from "./RepairMaterialCreateUpdateModal";

interface OwnProps {
  autocompleteProps: RepairMaterialAutocompleteProps;
  createUpdateRepairMaterialProps?: Pick<RepairMaterialCreateUpdateProps, "defaultValues">;
  createFormPlacement?: "modal" | "page";
  onCreateStart?: () => void;
  onCreate: (newValue: RepairMaterialDto) => void;
}

type Props = OwnProps;

export default function SelectOrCreateRepairMaterial({
  autocompleteProps,
  createUpdateRepairMaterialProps,
  createFormPlacement = "modal",
  onCreateStart,
  onCreate,
}: Props) {
  const [isCreate, setIsCreate] = useState(false);
  const [defaultValues, setDefaultValues] = useState<
    RepairMaterialCreateUpdateProps["defaultValues"] | undefined
  >(undefined);

  return (
    <Stack spacing={2}>
      {/* 1. Search repairMaterial */}
      {!isCreate && (
        <Box>
          <RepairMaterialAutocomplete
            {...autocompleteProps}
            withCreate
            onCreate={(newOption) => {
              setDefaultValues({
                ...createUpdateRepairMaterialProps?.defaultValues,
                name: newOption?.inputValue || undefined,
              });
              setIsCreate(true);
              onCreateStart && onCreateStart();
            }}
          />
        </Box>
      )}

      {isCreate && (
        <Box>
          {isCreate && (
            <>
              {createFormPlacement === "modal" && (
                <RepairMaterialCreateUpdateModal
                  open={isCreate}
                  onClose={() => setIsCreate(false)}
                  createUpdateProps={{
                    defaultValues: defaultValues,
                    onCreate: onCreate,
                    onSave: (newValue) => {
                      setIsCreate(false);
                    },
                  }}
                />
              )}

              {createFormPlacement === "page" && (
                <Stack spacing={1}>
                  <Stack direction='row' spacing={1} sx={{ alignItems: "center" }}>
                    <Button
                      variant='text'
                      color='text'
                      size='small'
                      startIcon={<AppIcon of='goBack' />}
                      onClick={() => setIsCreate(false)}
                    >
                      Back to search
                    </Button>

                    <Typography component='div' variant='subtitle1'>
                      Create new repair material
                    </Typography>
                  </Stack>

                  <RepairMaterialCreateUpdate
                    defaultValues={defaultValues}
                    onCreate={onCreate}
                    onSave={(newValue) => {
                      setIsCreate(false);
                    }}
                  />
                </Stack>
              )}
            </>
          )}
        </Box>
      )}
    </Stack>
  );
}
